import { axiosInstance } from "@/api/axiosInstance"
import { AxiosRequestConfig } from "axios"
import { FeedbackApi } from "swagger/api"
import { CreateFeedbackRequest } from "swagger/models"
import { Configuration } from "../../swagger/configuration"

// Anonymous feedback configuration - no access token
const getApiConfig = () =>
  new Configuration({
    basePath: process.env.NEXT_PUBLIC_API_URL,
    // No accessToken for anonymous feedback
  })

const apiConfiguration = getApiConfig()

const FEEDBACK_API = new FeedbackApi(apiConfiguration, apiConfiguration.basePath, axiosInstance)

export const sendFeedback = async (body: CreateFeedbackRequest, options?: AxiosRequestConfig) => {
  return FEEDBACK_API.createFeedback(body, options)
}
